import React, {useContext, useMemo} from "react";
import DeviceSimulator from "../../../../components/base/device-simulator";
import {UserHomepageStateContext, UserHomepageViewContext} from "../../index";
import {CircularProgress} from "@mui/material";
import UserWebHomepageBody from "./sections/body";

const UserWebHomepage = ({id}) => {
    const {zoom} = useContext(UserHomepageViewContext);
    const state = useContext(UserHomepageStateContext);
    const loading = useMemo(() => !state.updatedData, [state.updatedData])

    const content = useMemo(() => (
        <>
            {
                loading &&
                <div
                    className={'d-flex flex-column justify-content-center align-items-center flex-grow-1'}>
                    <CircularProgress size={50}/>
                </div>
            }
            {
                !loading &&
                <UserWebHomepageBody/>
            }
        </>
    ), [state, loading])

    return (
        <>
            <DeviceSimulator
                id={id}
                zoom={zoom}
                className={'web-simulator user-web-homepage'}
                device={'MacBook Pro'}
            >
                {content}
            </DeviceSimulator>
        </>
    )
}

export default UserWebHomepage;
